export default "__VITE_ASSET__xX$OZqkE__"